import { render, staticRenderFns } from "./WarehouseList.vue?vue&type=template&id=99fae8a8&scoped=true&"
import script from "./WarehouseList.vue?vue&type=script&lang=js&"
export * from "./WarehouseList.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseList.vue?vue&type=style&index=0&id=99fae8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fae8a8",
  null
  
)

export default component.exports